import {
  ErrorModalContext,
  getServerErrorMessage,
  LoggingServiceAdapter,
  NotificationAdapter,
} from '@g2-shared/common';
import { useContext } from 'react';

export const FETCH_AUTH_USER = 'FETCH_AUTH_USER';

export const FETCH_USER_COUNTRIES = 'FETCH_USER_COUNTRIES';

export const CHECK_AUTH = 'CHECK_AUTH';

export const GET_CLIENT_PERMISSIONS = 'GET_CLIENT_PERMISSIONS';

const userApiDefaultConfig = {
  retry: 0,
};

export const useUserApiDefaultConfig = (callerName: string, dismissibleError?: boolean) => {
  const { logError } = LoggingServiceAdapter();
  const { translateAndNotifyError } = NotificationAdapter();
  const { setError } = useContext(ErrorModalContext);

  return {
    ...userApiDefaultConfig,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    onError: (error: unknown) => {
      if (dismissibleError) {
        setError(getServerErrorMessage(error));
      } else {
        translateAndNotifyError(getServerErrorMessage(error));
      }
      logError(error, 'Error while calling User api', callerName);
    },
  };
};
